import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDrop } from "react-dnd";
import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import { MdOutlineCopyAll } from "react-icons/md";
import "react-resizable/css/styles.css";
import AppContext from "../../context/AppContext";
import Joyride from "react-joyride";
import { AiOutlineEdit } from "react-icons/ai";
import FieldModal from "./FieldModal";
import FileChooserPreview from "../common/FileChooserPreview";
import translations from "../common/Translations";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { isRTL } from "../../utils/rtl";
import { toast } from "../../utils/toast";

const ItemTypes = {
  ELEMENT: "element",
};

const DroppableArea = ({
  setDroppedItems, droppedItems, mainTab, setMainTab, allInputValues, setPreview, preview, setDragItems, dragItems, handleRemoveInput, setreportInput, setreportField,
  setShowRadioOptions, setSelectedRadioOption, setRadioButtons, radioButtons, page, isPageWise, setCollapse, setShowInput, isNewFieldDragged, setIsNewFieldDragged, setSelectedRadioId,
  setpdfInput, setCollapsedGroups, initialCollapseState, setPdfInput, setPdfIcon, setReportIcon, pdfInput, reportInput, isEdit, isClone,
  disallowedFieldTypes = []
}) => {
  const [itemSelected, setItemsSelected] = useState();
  const [openCalendarKey, setOpenCalendarKey] = useState(null);
  const { theme, runTour, workflowmaker, langMode, newfield, setNewfield } = useContext(AppContext);
  const isRtl = isRTL(langMode);
  const [queNo, setQueNo] = useState(1);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [fieldToEdit, setFieldToEdit] = useState(null);
  const pageRef = useRef(page);
  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    console.log("?? Preview updated in Parent....:", preview);
  }, [preview]);
  useEffect(() => {
    console.log("?? newfield updated in Parent....:", newfield);
  }, [newfield]);
  console.log('newfield', newfield)
  console.log(dragItems, "dragItems")

  useEffect(() => {
    if (!preview?.fieldName || !preview?.fieldType) return;

    setDragItems((prevItems) =>
      prevItems.map((item) => {
        if (item.uniqueKey === preview.uniqueKey) {
          return {
            ...item,
            fieldType: preview.fieldType,
          };
        }
        return item;
      })
    );
  }, [preview]);

  useEffect(() => {
    console.log("?? dragItems updated in Parent:", dragItems);
  }, [dragItems]);

  const [, drop] = useDrop(
    () => ({
      accept: ItemTypes.ELEMENT,
      drop: (item, monitor) => {
        // Second line of defence: the palette already hides these, but a field type
        // the current canvas doesn't allow must never make it in.
        if (disallowedFieldTypes.includes(item?.fieldType)) {
          toast.warn(
            translations[langMode].fieldNotAllowedInSafetyChecklist ??
            `"${item?.fieldName}" can't be used in a safety checklist.`
          );
          setIsNewFieldDragged(false);
          return;
        }

        const newUniqueKey = `${new Date().getTime()}`;

        let newQueNo = 1;
        let newItem = {};

        setDroppedItems((prevFields) => {
          if (prevFields.length > 0) {
            const highestQueNo = Math.max(
              ...prevFields.map((field) => field.queNo)
            );
            newQueNo = highestQueNo + 1;
          }

          newItem = {
            ...item,
            uniqueKey: newUniqueKey,
            page: page,
            queNo: newQueNo,
          };

          const updatedFields = [...prevFields, newItem].sort((a, b) => {
            if (a.page === b.page) {
              return a.queNo - b.queNo;
            }
            return a.page - b.page;
          });

          return updatedFields.map((field, index) => ({
            ...field,
            queNo: index + 1,
          }));
        });

        setDragItems((prevFields) => {
          const highestQueNo = prevFields.length > 0
            ? Math.max(...prevFields.map((field) => field.queNo)) + 1
            : 1;

          newItem = {
            ...item,
            uniqueKey: newUniqueKey,
            page: page,
            queNo: highestQueNo,
          };

          const updatedDragFields = [...prevFields, newItem].sort((a, b) => {
            if (a.page === b.page) {
              return a.queNo - b.queNo;
            }
            return a.page - b.page;
          });

          return updatedDragFields.map((field, index) => ({
            ...field,
            queNo: index + 1,
          }));
        });

        setPreview(newItem);
        setItemsSelected(newUniqueKey);

        if (!newItem.excelReportName) {
          console.error("Report name is missing for the newly dropped field");
          setPdfInput("");
        }
        if (!newItem.reportName) {
          console.error("PDF name is missing for the newly dropped field");
          setreportInput("");
        }
        if (newItem.excelReportName) {
          setPdfIcon(true)
        }
        else {
          setPdfIcon(false)
        }

        if (newItem.reportName) {
          setPdfIcon(true)
        }
        else {
          setPdfIcon(false)
        }

        handleRemoveInput();
        setIsNewFieldDragged(false);
        setSelectedRadioId(null);
        setCollapse(false);
        setCollapsedGroups([]);
        setreportField(false);
        setShowInput(false);
      },
    }),
    [page, queNo, disallowedFieldTypes, langMode]
  );


  const calculateHeight = (item) => {
    if (item.fieldType === "radio") {
      const visibleOptionCount = Array.isArray(item.allInputValues)
        ? item.allInputValues.filter(
          (option) => String(option?.inputValue ?? "").trim() !== ""
        ).length
        : 0;
      // Keep radio height aligned with the options that are actually rendered.
      return Math.max(4, visibleOptionCount + 2);
    }
    if (item.fieldType === "checkbox" && item.allInputValues) {
      // Option-based fields need extra vertical room for each choice row
      // inside react-grid-layout's fixed row units.
      return Math.max(5, item.allInputValues.length + 2);
    }
    return 4;
  };

  const gridWrapperRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useLayoutEffect(() => {
    const node = gridWrapperRef.current;
    if (!node) return;

    const updateWidth = () => {
      const style = window.getComputedStyle(node);
      const paddingX = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      setContainerWidth(node.clientWidth - paddingX);
    };
    updateWidth();

    const observer = new ResizeObserver(updateWidth);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const cols = containerWidth > 0 ? Math.max(1, Math.floor(containerWidth / 50)) : 1;
  const visibleItems = isPageWise
    ? dragItems.filter((item) => Number(item.page ?? 1) === Number(page))
    : dragItems;
  const layout = visibleItems.map((item) => ({
    i: item.uniqueKey,
    x: 0,
    y: 0,
    w: cols,
    h: calculateHeight(item),
    autoSize: true,
    isDraggable: true,
    isResizable: false,
    static: false,
  }));
  const previewLabelClass = "mb-1 block text-[13px] font-semibold leading-5 text-slate-800 dark:text-gray-300";
  const previewInputClass = `${theme === "dark"
    ? "dark:bg-gray-800 dark:border-gray-600 dark:text-gray-200"
    : theme === "high-contrast"
      ? "high-contrast"
      : "bg-slate-50"
    } block h-9 w-full rounded-[7px] border border-slate-200 px-3 py-0 text-[12.5px] leading-[34px] text-slate-800 shadow-sm transition duration-200 ease-in-out focus:border-[#236DB4] focus:outline-none focus:ring-[#EAF3FB]`;

  function radioIdSelected(items, targetUniqueKey) {
    let selectedRadioId = null;
    items.forEach((item) => {
      if (item.uniqueKey === targetUniqueKey) {
        selectedRadioId = item.radioId;
      } else if (item.radioInputValues && item.radioInputValues.length > 0) {
        const updatedRadioInputValues = radioIdSelected(
          item.radioInputValues,
          targetUniqueKey
        );
        if (updatedRadioInputValues) {
          selectedRadioId = updatedRadioInputValues;
        }
      }
    });
    return selectedRadioId;
  }
  const checkIsChildContains = (radioInputValues, uniqueKey) => {
    if (radioInputValues && Array.isArray(radioInputValues)) {
      for (const item of radioInputValues) {
        if (item.uniqueKey === uniqueKey) {
          return true;
        }
        if (item.radioInputValues && Array.isArray(item.radioInputValues)) {
          if (checkIsChildContains(item.radioInputValues, uniqueKey)) {
            return true;
          }
        }
      }
    }
    return false;
  };

  function isOrphan(itemUniqueKey) {
    const item = droppedItems.find(
      ({ uniqueKey }) => uniqueKey === itemUniqueKey
    );
    if (item) {
      if (
        item.radioInputValues === undefined ||
        (Array.isArray(item.radioInputValues) &&
          item.radioInputValues.length === 0)
      ) {
        return true;
      }
    } else {
      return false;
    }
  }

  function findAllParentKeys(items, childKey, path = []) {
    for (const item of items) {
      if (item.uniqueKey === childKey) {
        return path;
      } else if (item.radioInputValues) {
        const result = findAllParentKeys(
          item.radioInputValues,
          childKey,
          path.concat(item.uniqueKey)
        );
        if (result) return result;
      }
    }
    return null;
  }
  function updateRadioButtonsVisibility(preview) {
    const parentKeys = findAllParentKeys(droppedItems, preview);
    const updatedRadioButtons = radioButtons.map((button) => {
      const isParent = parentKeys && parentKeys.includes(button.uniqueKey);
      if (
        isParent ||
        button.uniqueKey === preview ||
        isOrphan(button.uniqueKey)
      ) {
        return { ...button, isShow: true };
      } else {
        return { ...button, isShow: false };
      }
    });
    setRadioButtons(updatedRadioButtons);
    setShowRadioOptions(true);
  }
  const handleItemClick = (previewKey) => {

    const previewfield = dragItems.find(
      (item) => item.uniqueKey === previewKey,
      setIsNewFieldDragged(true),
      setCollapse(false)
    );
    setPreview(previewfield);

    if (!previewfield.excelReportName) {
      console.error("Report name is missing for the selected field");
    }
    if (!previewfield.reportName) {
      console.error("PDF name is missing for the selected field");
    }
    console.log("preview", preview)
    if (preview.excelReportName) {
      setPdfIcon(true)
    }
    else {
      setPdfIcon(false)
    }

    if (preview.reportName) {
      setPdfIcon(true)
    }
    else {
      setPdfIcon(false)
    }

    setreportInput(previewfield.reportName || "");
    setPdfInput(previewfield.excelReportName || "");
    if (previewfield.excelReportName) {
      setPdfIcon(true)
    }
    if (!previewfield.reportName && !previewfield.excelReportName) {
      setreportField(false);
      setShowInput(false);
    } else if (previewfield.reportName && !previewfield.excelReportName) {
      setreportField(true);
      setReportIcon(true)
      setShowInput(false);
    } else if (!previewfield.reportName && previewfield.excelReportName) {
      setreportField(false);
      setShowInput(true);
      setPdfIcon(true)
    } else {
      setreportField(true);
      setShowInput(true);
    }
    setItemsSelected(previewKey);
    const selectedRadioId = radioIdSelected(droppedItems, previewKey);
    setSelectedRadioOption(selectedRadioId);

    let droppedValues = [...droppedItems];
    const index = droppedValues.findIndex(
      (input) => input.uniqueKey === previewKey
    );
    if (index !== -1) {
      const updatedRadioButtons = radioButtons.map((button) => {
        const isShow = !checkIsChildContains(
          droppedValues[index].radioInputValues,
          button.uniqueKey
        );
        return { ...button, isShow };
      });
      const updatedRadioButtons2 = droppedItems.map((button) => {
        const isShow = !checkIsChildContains(
          droppedValues[index].radioInputValues,
          button.uniqueKey
        );
        return { ...button, isShow };
      });
      setRadioButtons(updatedRadioButtons);
      setShowRadioOptions(true);
    } else {
      if (!preview.allInputValues) {
        const updatedRadioButtons = radioButtons.map((button) => {
          const isShow = true;
          return { ...button, isShow };
        });
        setRadioButtons(updatedRadioButtons);
      } else {
        updateRadioButtonsVisibility(previewKey);
      }
    }
  };
  const radioValues = dragItems.find(
    (item) => item.fieldType === "radio"
  )?.allInputValues;

  const handleDragStop = (layout) => {

    const sortedLayout = [...layout].sort((a, b) => a.y - b.y);

    const reorderItems = (prevItems) => {
      // Page-wise OFF: the whole canvas shows every page's fields together
      // (see `visibleItems` above), so reorder every field by the layout
      // order -- no page grouping (which is what produced stray `{ queNo }`
      // entries before). This does NOT touch each item's `page` -- it used
      // to force `page: 1` on every field here, which silently destroyed
      // any page-2+ assignment the moment someone reordered the canvas
      // while Page Wise was off (and there was no way to get it back).
      // Page Wise being off only means "don't group/gate by page for
      // display" (same short-circuit PreviewForm.js's `!isPageWise || ...`
      // already relies on) -- it should never mean "collapse everyone onto
      // page 1", so `page` now survives a reorder untouched.
      if (!isPageWise) {
        const reorderedByLayout = sortedLayout
          .map((layoutItem) =>
            prevItems.find((item) => item.uniqueKey === layoutItem.i)
          )
          .filter(Boolean);
        // Keep any item the layout didn't report, so nothing is ever dropped.
        const seen = new Set(reorderedByLayout.map((item) => item.uniqueKey));
        const remaining = prevItems.filter((item) => !seen.has(item.uniqueKey));
        return [...reorderedByLayout, ...remaining].map((item, index) => ({
          ...item,
          queNo: index + 1,
        }));
      }

      // Page-wise ON: only reorder the page currently shown.
      const groupedByPage = prevItems.reduce((acc, item) => {
        if (!acc[item.page]) acc[item.page] = [];
        acc[item.page].push(item);
        return acc;
      }, {});
      const currentPageItems = groupedByPage[page] || [];
      // `sortedLayout` spans every page, so map then drop entries that don't
      // belong to the current page (otherwise they become `{ queNo }` ghosts).
      const reorderedCurrentPageItems = sortedLayout
        .map((layoutItem) =>
          currentPageItems.find((item) => item.uniqueKey === layoutItem.i)
        )
        .filter(Boolean);
      groupedByPage[page] = reorderedCurrentPageItems;
      return Object.values(groupedByPage).flat().map((item, index) => ({
        ...item,
        queNo: index + 1, // Maintain sequential numbering across pages
      }));
    };

    setDroppedItems((prevItems) => reorderItems(prevItems));
    setDragItems((prevDragItems) => reorderItems(prevDragItems));
  };

  return (
    <>
      <Joyride
        steps={workflowmaker}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        scrollToFirstStep
        styles={{
          options: {
            arrowColor: "#fff",
            overlayColor: "rgba(0, 0, 0, 0.5)",
            primaryColor: "#4C3BCF",
            textColor: "#333",
            zIndex: 1000,
          },
          tooltip: {
            borderRadius: "10px",
          },
          buttonSkip: {
            color: "#4C3BCF",
          },
          buttonNext: {
            backgroundColor: "#4C3BCF",
          },
          buttonBack: {
            color: "#4C3BCF",
          },
        }}
      />
      <div
        ref={drop}
        className={`droparea h-full min-h-0 w-full overflow-x-auto overflow-y-auto rounded-lg border border-slate-200 bg-[#F7FAFF] shadow-sm ${theme === "dark"
          ? "dark-mode "
          : theme === "high-contrast"
            ? "high-contrast"
            : ""
          }`}>
        <div ref={gridWrapperRef} className="px-3 py-3">
        {/* Only mount the grid when the current page actually has fields.
            react-grid-layout sizes its container from its own internal layout
            state, which kept the previous page's height when you switched to a
            freshly added empty page -- leaving blank reserved space above the
            "drag a field here" card. */}
        {visibleItems.length > 0 && (
        <GridLayout
          className="layout w-full"
          layout={layout}
          cols={cols}
          rowHeight={20}
          width={containerWidth}
          containerPadding={[0, 0]}
          isResizable={false}
          autoSize
          compactType="vertical" // Try this instead of null
          onDragStop={handleDragStop}
        >
          {visibleItems.map((item) => {
            return (
              <div
                key={item.uniqueKey}
                data-grid={layout.find((l) => l.i === item.uniqueKey)}
                className={`w-full rounded-[10px] border bg-white px-3 py-2.5 ${!item.excelReportName
                  ? "border-red-500"
                  : itemSelected === item.uniqueKey
                    ? "border-green-400"
                    : "border-slate-300"
                  } ${itemSelected === item.uniqueKey ? "shadow-[0_0_0_3px_#E8F7EF]" : ""} ${openCalendarKey === item.uniqueKey ? "z-[120]" : "z-[1]"} ${theme === "dark"
                    ? "dark-mode "
                    : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                  } transition-all duration-150 ease-in-out hover:border-[#BEDAF0] hover:shadow-sm`}
                onClick={() => handleItemClick(item.uniqueKey)}
              >
                <div
                  className={`relative flex flex-col items-center px-1.5 text-[12px] leading-5 ${
                    item.fieldType === "radio" || item.fieldType === "date"
                      ? "pb-2.5 pt-2.5"
                      : "pb-1.5 pt-2.5"
                  }`}
                  dir={isRtl ? "rtl" : "ltr"}
                >
                  <div
                    className={`pointer-events-none absolute top-1.5 ${isRtl ? "left-1.5" : "right-1.5"} whitespace-nowrap rounded-[5px] bg-slate-50 px-2 py-0.5 text-[10.5px] font-bold uppercase tracking-[0.02em] text-slate-400 dark:text-gray-300`}
                  >
                    {translations[langMode].fieldtype} : {translations[langMode]?.[`wfType_${item.fieldType}`] ?? item.fieldType}
                  </div>

                  <div className={`flex w-full items-start ${isRtl ? "pl-28" : "pr-28"}`}>
                    <div
                      className={`${isRtl ? "ml-2" : "mr-2"} mt-0.5 inline-flex h-[19px] min-w-[19px] shrink-0 items-center justify-center rounded-[5px] bg-slate-100 px-1 text-[10.5px] font-bold leading-[19px] text-slate-600 dark:text-gray-300`}
                    >
                      {item.queNo}.
                    </div>
                    {item.fieldType === "text" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id}
                        >
                          {item.fieldName}
                        </label>
                        <input
                          id={item.id}
                          className={previewInputClass}
                          type="text"
                          placeholder={translations[langMode]?.wfEnterYourInput ?? "Enter your input"}
                        />
                      </div>
                    )}
                    {item.fieldType === "date" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id} // Assuming each item has a unique id
                        >
                          {item.fieldName}{" "}
                        </label>
                        <DatePicker
                          id={item.id}
                          selected={null}
                          onChange={() => {}}
                          onCalendarOpen={() => setOpenCalendarKey(item.uniqueKey)}
                          onCalendarClose={() => setOpenCalendarKey(null)}
                          placeholderText="Select date"
                          className={previewInputClass}
                          calendarClassName="!rounded-lg shadow-lg"
                          popperClassName="!z-[100000]"
                          popperPlacement="bottom-start"
                          popperContainer={({ children }) => (
                            <div style={{ position: "fixed", zIndex: 100000 }}>{children}</div>
                          )}
                        />
                      </div>
                    )}
                    {item.fieldType === "time" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id} // Assuming each item has a unique id
                        >
                          {item.fieldName}{" "}
                        </label>
                        <input
                          id={item.id} // Matching the input's id with the label's htmlFor
                          className={previewInputClass}
                          type="time" /* ... */
                        />
                      </div>
                    )}
                    {item.fieldType === "textarea" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id} // Assuming each item has a unique id
                        >
                          {item.fieldName}
                        </label>
                        <input
                          className={previewInputClass}
                          type="textarea" /* ... */
                        />
                      </div>
                    )}
                    {item.fieldType === "scan" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id}
                        >
                          {item.fieldName}
                        </label>
                        <input
                          className={previewInputClass}
                          type="textarea" /* ... */
                        />
                      </div>
                    )}
                    {item.fieldType === "number" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id} // Assuming each item has a unique id
                        >
                          {item.fieldName}{" "}
                        </label>
                        <input
                          className={previewInputClass}
                          type="number" /* ... */
                        />
                      </div>
                    )}
                    {item.fieldType === "email" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id} // Assuming each item has a unique id
                        >
                          {item.fieldName}{" "}
                        </label>
                        <input
                          className={previewInputClass}
                          type="email"
                        />
                      </div>
                    )}
                    {(item.fieldType === "file" || item.fieldType === "multi_image") && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id} // Assuming each item has a unique id
                        >
                          {item.fieldName}{" "}
                        </label>
                        <FileChooserPreview
                          id={item.id}
                          disabled
                          multiple={item.fieldType === "multi_image" ? true : !!item.multiple}
                          accept={item.accept || "image/*"}
                          theme={theme}
                          size="sm"
                          chooseFileText={translations[langMode]?.chooseFile ?? "Choose File"}
                          fileName={translations[langMode]?.noFile ?? "No file chosen"}
                        />
                      </div>
                    )}
                    {item.fieldType === "checkbox" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.uniqueKey} // Assuming each item has a unique uniqueKey
                        >
                          {item.fieldName}{" "}
                        </label>
                        {item.allInputValues &&
                          item.allInputValues.length > 0 ? (
                          item.allInputValues.map((inputItem) => (
                            <div key={inputItem.inputKey} className="mt-1.5 flex items-center gap-2 rounded-md px-1 py-0.5">
                              <input
                                type="checkbox"
                                id={inputItem.inputKey} // Assuming each inputItem has a unique inputKey
                                value={inputItem.inputValue} // Assuming each inputItem has an inputValue
                                className="h-3.5 w-3.5 rounded border-slate-300 text-[#236DB4] focus:ring-[#EAF3FB]"
                              />
                              <label
                                htmlFor={inputItem.inputKey}
                                className="text-xs text-slate-700"
                              >
                                {inputItem.inputValue}
                              </label>
                            </div>
                          ))
                        ) : (
                          <p className="text-xs text-slate-500">
                            No checkbox options available
                          </p>
                        )}
                      </div>
                    )}
                    {item.fieldType === "radio" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id} // Assuming each item has a unique id
                        >
                          {item.fieldName}{" "}
                        </label>
                        {item.allInputValues &&
                          item.allInputValues.length > 0 ? (
                          item.allInputValues.map(
                            (input, index) =>
                              input.inputValue !== "" && (
                                <div
                                  key={`${item.uniqueKey}-${index}`}
                                  className="mt-1.5 flex items-center gap-2 rounded-md px-1 py-0.5 text-xs"
                                >
                                  <input
                                    type="radio"
                                    id={`${item.uniqueKey}-input-${index}`}
                                    fieldName={`${item.uniqueKey}-options`}
                                    value={input.inputValue}
                                    className="h-3.5 w-3.5 border-slate-300 text-[#236DB4] focus:ring-[#EAF3FB]"
                                  />
                                  <label
                                    htmlFor={`${item.uniqueKey}-input-${index}`}
                                    className="text-slate-700"
                                  >
                                    {input.inputValue}
                                  </label>
                                </div>
                              )
                          )
                        ) : (
                          <p className="text-xs text-slate-500">{translations[langMode]?.wfNoRadioOptions ?? "No radio options available"}</p>
                        )}
                      </div>
                    )}
                    {item.fieldType === "select" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.uniqueKey}
                        >
                          {item.fieldName}
                        </label>
                        <select
                          className={previewInputClass}
                          id={item.uniqueKey}
                        >
                          {item.allInputValues ? (
                            item.allInputValues.map((inputItem) => (
                              <option
                                key={inputItem.inputKey}
                                value={inputItem.inputValue}
                              >
                                {inputItem.inputValue}
                              </option>
                            ))
                          ) : (
                            <option value="">{translations[langMode].nooptionavailable}</option>
                          )}
                        </select>
                      </div>
                    )}
                    {item.fieldType === "ocr" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id}
                        >
                          {item.fieldName}
                        </label>
                        <input
                          id={item.id}
                          className={previewInputClass}
                          type="text"
                          placeholder={translations[langMode]?.wfEnterYourInput ?? "Enter your input"}
                        />
                      </div>
                    )}  
                    {item.fieldType === "gps" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id}
                        >
                          {item.fieldName}
                        </label>
                        <input
                          id={item.id}
                          className={previewInputClass}
                          type="text"
                          placeholder={translations[langMode]?.wfEnterYourInput ?? "Enter your input"}
                        />
                      </div>
                    )}
                    {item.fieldType === "signal_quality" && (
                      <div className="w-full">
                        <label
                          className={previewLabelClass}
                          htmlFor={item.id}
                        >
                          {item.fieldName}
                        </label>
                        <input
                          id={item.id}
                          className={previewInputClass}
                          type="text"
                          placeholder={translations[langMode]?.wfEnterYourInput ?? "Enter your input"}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </GridLayout>
        )}
        {visibleItems.length === 0 && (
          <div
            className={`mx-2 my-4 rounded-xl border border-[#D6E7F6] bg-white/90 p-5 ${theme === "dark"
              ? "dark-mode "
              : theme === "high-contrast"
                ? "high-contrast"
                : ""
              }`}
          >
            <div className="flex w-full items-center justify-center">
              <label
                htmlFor="dropzone-file"
                className={`${theme === "dark"
                  ? "dark-mode "
                  : theme === "high-contrast"
                    ? "high-contrast"
                    : ""
                  } flex min-h-[150px] w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-[#BEDAF0] bg-[#F8FBFF] px-6 py-8 text-center transition-colors hover:bg-[#F1F7FD]`}
              >
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-sm">
                  <MdOutlineCopyAll className="text-xl text-slate-400" />
                </span>
                <h6 className="text-[13px] font-semibold text-slate-600">
                  Drag a field here to get started
                </h6>
                <p className="max-w-[26rem] text-[12px] leading-5 text-slate-500">
                  {translations[langMode]?.dragElementsFromLeftPanel ?? "Drag your elements from the left panel"}
                </p>
              </label>
            </div>
          </div>
        )}
        </div>
      </div>
    </>
  );
};

export default DroppableArea;
